import { Tooltip } from "antd";
import { FormikProps } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { IArticle } from "../../../../../../@types/Articles";
import { CircleChecked } from "../../../../../../assets/icons/CircleChecked";
import { CircleUnchecked } from "../../../../../../assets/icons/CircleUncheked";
import { IOption } from "../../../../../../components/SelectDropdown";
import { useWardLabel } from "../../../../../../hooks/useWardLabel";
import { getLongFormattedDate } from "../../../../../../utils/dateFormatter";
import {
  ContentContainer,
  ContentRow,
  ContentSubRow,
  DescriptionText,
  RulesButton,
} from "./SettingsSection.styles";

interface ISettingsSectionProps {
  formik: FormikProps<IArticle>;
  wardOptions: IOption[];
}

export function SettingsSection({
  formik,
  wardOptions,
}: ISettingsSectionProps) {
  const { t } = useTranslation();

  const wardLabel = useWardLabel();
  const [wards, setWards] = useState<string>();
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    const selectedWards: string[] = [];

    wardOptions.forEach((ward) => {
      if (formik.values.wards?.includes(ward.value)) {
        selectedWards.push(ward.label);
      }
    });

    setWards(selectedWards.join(", "));
  }, [formik, wardOptions]);

  useEffect(() => {
    setIsPublished(formik.values.published);
  }, []);

  return (
    <ContentContainer>
      <ContentRow>
        <ContentSubRow>
          <p>{t("careInfo_settings_reads")}</p>
          <DescriptionText>{formik.values.numberOfReads}</DescriptionText>
        </ContentSubRow>
        <ContentSubRow>
          <p>{t("careInfo_settings_author")}</p>
          <DescriptionText>
            {formik.values.createdBy ? formik.values.createdBy : "-"}
          </DescriptionText>
        </ContentSubRow>
      </ContentRow>
      <ContentRow>
        <ContentSubRow>
          <p>{t("careInfo_settings_lastEdited")}</p>
          <DescriptionText>
            {formik.values.lastEdited
              ? getLongFormattedDate(formik.values.lastEdited)
              : "-"}
          </DescriptionText>
        </ContentSubRow>
        <ContentSubRow>
          <p>{wardLabel.plural}</p>
          <DescriptionText>
            {wards === undefined || wards === "" ? "-" : wards}
          </DescriptionText>
        </ContentSubRow>
      </ContentRow>
      <ContentRow>
        <ContentSubRow>
          <p>{t("careInfo_settings_rules")}</p>
          <Tooltip
            title={t("careInfo_settings_rulesDisabled")}
            arrow={false}
            placement="top"
            zIndex={3000}
            styles={{
              body: {
                padding: "6px 12px",
                minHeight: "40px",
                width: "max-content",
                borderRadius: "4px !important",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: "'Open Sans', sans-serif",
              },
            }}
          >
            <RulesButton>{t("careInfo_settings_addRules")}</RulesButton>
          </Tooltip>
        </ContentSubRow>
        <ContentSubRow>
          <p>{t("careInfo_settings_published")}</p>
          <DescriptionText>
            {isPublished ? <CircleChecked /> : <CircleUnchecked />}
          </DescriptionText>
        </ContentSubRow>
      </ContentRow>
    </ContentContainer>
  );
}
